<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
<!--    <div class="table-operator">-->
<!--      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
<!--      <a-button type="primary" icon="download" @click="handleExportXls('view_efs_stl_settle_confirm')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
<!--    </div>-->

    <!-- table区域-begin -->
    <div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <span slot="action" slot-scope="text, record">-->
<!--          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>-->

<!--          <a-divider type="vertical" />-->
<!--          <a-dropdown>-->
<!--            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>-->
<!--            <a-menu slot="overlay">-->
<!--              <a-menu-item>-->
<!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
<!--                  <a>{{$t('button.delete')}}</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
<!--            </a-menu>-->
<!--          </a-dropdown>-->
<!--        </span>-->

      </a-table>
    </div>

    <viewEfsStlSettleConfirm-modal ref="modalForm" @ok="modalFormOk"></viewEfsStlSettleConfirm-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ViewEfsStlSettleConfirmModal from './modules/ViewEfsStlSettleConfirmModal'

  export default {
    name: "ViewEfsStlSettleConfirmList",
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ViewEfsStlSettleConfirmModal
    },
    data () {
      return {
        description: 'view_efs_stl_settle_confirm管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.batchCode',
            scopedSlots: { title: 'tableHeader.batchCode'},
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
             slotName: 'tableHeader.materialCommonNameFileNo',
            scopedSlots: { title: 'tableHeader.materialCommonNameFileNo'},
            align:"center",
            dataIndex: 'mmCode'
          },
          {
             slotName: 'tableHeader.materialCommonName',
            scopedSlots: { title: 'tableHeader.materialCommonName'},
            align:"center",
            dataIndex: 'mmName'
          },
          {
             slotName: 'tableHeader.materialCategory',
             scopedSlots: { title: 'tableHeader.materialCategory'},
            align:"center",
            dataIndex: 'mmCategory'
          },
          {
             slotName: 'tableHeader.description',
            scopedSlots: { title: 'tableHeader.description'},
            align:"center",
            dataIndex: 'mmCategoryName'
          },
          {
             slotName: 'tableHeader.unitOfMeasurement',
            scopedSlots: { title: 'tableHeader.unitOfMeasurement'},
            align:"center",
            dataIndex: 'unit'
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'price'
          },
          {
            title:'拓展属性',
            align:"center",
            dataIndex: 'costItemCode'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/settlePickingList/viewEfsStlSettleConfirm/list",
          delete: "/settlePickingList/viewEfsStlSettleConfirm/delete",
          deleteBatch: "/settlePickingList/viewEfsStlSettleConfirm/deleteBatch",
          exportXlsUrl: "/settlePickingList/viewEfsStlSettleConfirm/exportXls",
          importExcelUrl: "settlePickingList/viewEfsStlSettleConfirm/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>